import { Typography } from "antd";
import React, { useRef } from "react";
import { useIntl } from "react-intl";
import SeriesList from "./SeriesList";

const SeriesTab = () => {
  const { formatMessage } = useIntl();
  const reloadSeriesRef = useRef(null);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }} className={"mb-2"}>
        <Typography.Title level={4}>
          {formatMessage({
            id: "series",
            defaultMessage: "Series",
          })}
        </Typography.Title>
      </div>
      <SeriesList reloadSeriesRef={reloadSeriesRef} />
    </>
  );
};

export default SeriesTab;
